import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../../actions/index.types'
import { toast } from 'react-toastify';
import * as req from '../../../../axios/request/SocietyPortal/AccountReportsReqs/AccountReportsReqs'

const extractError = (e, fallback) =>
    e?.response?.data?.message || e?.data?.message || e?.message || fallback;

const make = ({ reqFn, successType, failureType, failureMsg }) => {
    return function* (action) {
        try {
            const result = yield call(reqFn, action);
            if (result?.success === true) {
                yield put({ type: successType, payload: result });
            } else {
                const msg = result?.message || failureMsg;
                yield put({ type: failureType, message: msg });
                toast.error(msg);
            }
        } catch (e) {
            console.log(e);
            const msg = extractError(e, failureMsg);
            yield put({ type: failureType, message: msg });
            toast.error(msg);
        }
    };
};

const getIncomeExpenditureReport = make({
    reqFn: req.getIncomeExpenditureReportReq,
    successType: types.GET_INCOME_EXPENDITURE_REPORT_SUCCESS,
    failureType: types.GET_INCOME_EXPENDITURE_REPORT_FAILURE,
    failureMsg: 'Failed to load Income & Expenditure report',
});

const getBalanceSheetReport = make({
    reqFn: req.getBalanceSheetReportReq,
    successType: types.GET_BALANCE_SHEET_REPORT_SUCCESS,
    failureType: types.GET_BALANCE_SHEET_REPORT_FAILURE,
    failureMsg: 'Failed to load Balance Sheet',
});

const getTrialBalanceReport = make({
    reqFn: req.getTrialBalanceReportReq,
    successType: types.GET_TRIAL_BALANCE_REPORT_SUCCESS,
    failureType: types.GET_TRIAL_BALANCE_REPORT_FAILURE,
    failureMsg: 'Failed to load Trial Balance',
});

const getGroupLedgerReport = make({
    reqFn: req.getGroupLedgerReportReq,
    successType: types.GET_GROUP_LEDGER_REPORT_SUCCESS,
    failureType: types.GET_GROUP_LEDGER_REPORT_FAILURE,
    failureMsg: 'Failed to load Group Ledger',
});

const getMonthlyIncomeReport = make({
    reqFn: req.getMonthlyIncomeReportReq,
    successType: types.GET_MONTHLY_INCOME_REPORT_SUCCESS,
    failureType: types.GET_MONTHLY_INCOME_REPORT_FAILURE,
    failureMsg: 'Failed to load Monthly Income report',
});

const getMonthlyExpenditureReport = make({
    reqFn: req.getMonthlyExpenditureReportReq,
    successType: types.GET_MONTHLY_EXPENDITURE_REPORT_SUCCESS,
    failureType: types.GET_MONTHLY_EXPENDITURE_REPORT_FAILURE,
    failureMsg: 'Failed to load Monthly Expenditure report',
});

export default function* AccountReportsSaga() {
    yield takeLatest(types.GET_INCOME_EXPENDITURE_REPORT, getIncomeExpenditureReport);
    yield takeLatest(types.GET_BALANCE_SHEET_REPORT, getBalanceSheetReport);
    yield takeLatest(types.GET_TRIAL_BALANCE_REPORT, getTrialBalanceReport);
    yield takeLatest(types.GET_GROUP_LEDGER_REPORT, getGroupLedgerReport);
    yield takeLatest(types.GET_MONTHLY_INCOME_REPORT, getMonthlyIncomeReport);
    yield takeLatest(types.GET_MONTHLY_EXPENDITURE_REPORT, getMonthlyExpenditureReport);
}
